import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import Navbar from "../navbar/navbar";
import AlertConfirmation from "../../common/AlertConfirmation.component";
import DatePicker from "react-datepicker";
import { createPrathana, getPrathanaMasterList } from "../../services/admin.service";
import { useNavigate } from "react-router-dom";

const PrathanaMasterListComponent = () => {

    const [prathanaList, setPrathanaList] = useState([]);
    const loginId = Number(localStorage.getItem('loginId'));
    const navigate = useNavigate();

    useEffect(() => {
        fetchPrathanaList();
    }, []);

    const fetchPrathanaList = async () => {
        try {
            const response = await getPrathanaMasterList();
            if (response) {
                setPrathanaList(response);
            } else {
                setPrathanaList([]);
                Swal.fire("Error", "Failed to fetch Prathana list", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong while fetching Prathana list", "error");
            console.error(error);
        }
    };

    const getMinDate = () => {
        const currentDate = new Date();
        const minYear = currentDate.getFullYear() - 20;
        return new Date(minYear, currentDate.getMonth(), currentDate.getDate());
    };
    const getMaxDate = () => {
        const currentDate = new Date();
        const maxYear = currentDate.getFullYear() + 50;
        return new Date(maxYear, currentDate.getMonth(), currentDate.getDate());
    };

    const validationSchema = Yup.object({
        newRate: Yup.number()
            .typeError("Rate must be a number")
            .positive("Rate must be positive")
            .required("New rate is required"),
        fromDate: Yup.date()
            .required("From Date is required"),
        toDate: Yup.date()
            .min(Yup.ref('fromDate'), 'To Date must be after From Date')
            .required("To Date is required")
    });

    const initialValues = {
        newRate: "",
        fromDate: null,
        toDate: null
    };

    const handleSubmit = async (values, { resetForm }) => {
        resetForm();
        try {
            const payload = {
                prathanaMandiraName: "Prarthana Mandira",
                rate: values.newRate,
                fromDate: values.fromDate ? values.fromDate.toISOString().split("T")[0] : null,
                toDate: values.toDate ? values.toDate.toISOString().split("T")[0] : null,
                isValid: 1,
                isActive: 1,
                createdBy: loginId,
                createdDate: new Date().toISOString().split("T")[0],
            };
            const confirm = await AlertConfirmation({ title: "Are you sure to update!", message: '' });
            if (!confirm) return;
            const result = await createPrathana(payload);
            if (result) {
                Swal.fire({
                    icon: "success",
                    title: "Rate Updated",
                    text: `New Prathana Mandir Rate: ${values.newRate}`,
                });
                fetchPrathanaList();
            } else {
                Swal.fire("Error", "Failed to update rate", "error");
            }
            resetForm();
        } catch (error) {
            Swal.fire("Error", "Failed to update rate", "error");
        }
    };

    const handleBack = () => {
        navigate("/dashboard");
    };


    return (
        <div className="card">
            <Navbar />
            <div className="card-body">
                <div className="col-md-12 text-center">
                    <h3 className="admin-custom-heading">Manage Prathana</h3>
                </div>
            </div>
            <div className="container mb-4">
                <div className="card p-4 shadow-lg">
                    <div className="card-header text-center bg-primary text-white fw-bold fs-4">
                        Prarthana Mandir Rate Update
                    </div>
                    <div className="card-body">
                        <div className="mb-3">
                            {prathanaList.length > 0 && (
                                <>
                                    <label className="form-label fw-semibold">Current Prathana Mandir Rate</label>
                                    <div className="form-control-plaintext fs-4 text-success">
                                        ₹{prathanaList[0]?.rate}
                                    </div>
                                </>
                            )}
                        </div>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ setFieldValue, values }) => (
                                <Form>
                                    <div className="row mb-3">
                                        {/* New Rate */}
                                        <div className="col-md-4">
                                            <label htmlFor="newRate" className="form-label fw-semibold">
                                                New Prarthana Mandir Rate
                                            </label>
                                            <Field
                                                type="text"
                                                name="newRate"
                                                className="form-control"
                                                placeholder="New Rate"
                                            />
                                            <ErrorMessage
                                                name="newRate"
                                                component="div"
                                                className="text-danger mt-1"
                                            />
                                        </div>

                                        {/* From Date */}
                                        <div className="col-md-4">
                                            <label htmlFor="fromDate" className="form-label fw-semibold">
                                                From Date
                                            </label>
                                            <DatePicker
                                                id="fromDate"
                                                name="fromDate"
                                                selected={values.fromDate}
                                                onChange={(date) => setFieldValue("fromDate", date)}
                                                className="form-control my-1"
                                                placeholderText="From Date"
                                                dateFormat="dd-MM-yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                                minDate={getMinDate()}
                                                maxDate={getMaxDate()}
                                                onKeyDown={(event) => event.preventDefault()}
                                            />
                                            <ErrorMessage
                                                name="fromDate"
                                                component="div"
                                                className="text-danger mt-1"
                                            />
                                        </div>

                                        {/* To Date */}
                                        <div className="col-md-4">
                                            <label htmlFor="toDate" className="form-label fw-semibold">
                                                To Date
                                            </label>
                                            <DatePicker
                                                id="toDate"
                                                name="toDate"
                                                selected={values.toDate}
                                                onChange={(date) => setFieldValue("toDate", date)}
                                                className="form-control my-1"
                                                placeholderText="To Date"
                                                dateFormat="dd-MM-yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                                minDate={values.fromDate || getMinDate()}
                                                maxDate={getMaxDate()}
                                                onKeyDown={(event) => event.preventDefault()}
                                            />
                                            <ErrorMessage
                                                name="toDate"
                                                component="div"
                                                className="text-danger mt-1"
                                            />
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        <button type="submit" className="submit me-2">
                                            {prathanaList.length > 0 ? "Update" : "Submit"}
                                        </button>
                                        <button type="reset" className="back" onClick={handleBack}>
                                            Cancel
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PrathanaMasterListComponent;